import { render, staticRenderFns } from "./bankAccountCreateModal.vue?vue&type=template&id=4272b296&"
import script from "./bankAccountCreateModal.vue?vue&type=script&lang=ts&"
export * from "./bankAccountCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports